const emojis = ['😎', '🍀', '⏰', '🥣', '🌎', '💖', '🐵', '👋'];
const pair_emojis = [...emojis, ...emojis];
const initRevealState = [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false];

export{emojis, pair_emojis, initRevealState};

